// extracted by mini-css-extract-plugin
module.exports = {"root":"_28v5p","bg":"TsxhR"};